import type { FaireProductEntity } from "../../entity_types/product";

export const p_hmubyf4f8e: FaireProductEntity = {
  token: "p_hmubyf4f8e",
  type: "product",
  name: "Guava Rose Corpse Reviver 12pk",
  brandToken: "b_pgy9sh2kad",
  brandName: "Corpse Reviver",
  imageUrl:
    "https://cdn.faire.com/fastly/8aa944e10bb55388ebc1c79dbadeecaba9befd428c0ad8810cabaa7ad2e50a01.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4fd9004db3e66de95c0b8c29c9c8a1e1df0c1b141f142ae404a5e25dceefef3a.jpeg",
    "https://cdn.faire.com/fastly/7cf3766b92a03f7ee9977271a820e0f8b938adde65492d83901078a2796f584e.png",
    "https://cdn.faire.com/fastly/6400716c1b52ed220d6d744d2e8f9b8a2bb31fc2cdc4aebbacc491c38596b1ca.png",
    "https://cdn.faire.com/fastly/f30e7ce1ad836a521a0a507cac568ec8c39d60aa03f89e64ca257c31fbce3be3.png",
  ],
  priceDollars: 20.97,
  description:
    "Taste bright guava with subtle rose notes while your body rehydrates and recovers. Guava Rose Corpse Reviver pairs delicious flavor with functional electrolytes and clean ingredients which are perfect for everyday balance or post-activity refreshment.\n\nBalanced hydration - Electrolytes your body actually uses\nTropical refreshment - Juicy guava with floral rose notes\nEveryday balance - Helps your body reset after activity or mid-day slump\nClean ingredients - No artificial colors, sugars, or flavors. Just real juice and sugar.\n",
  tags: [],
  msrpDollars: 52.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:53.373Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
